import React from 'react';

export default function FormattedPlural (props) {
    return (
        <span>{props.value === 1 ? props.one : props.other}</span>
    );
}
